(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cartes-collections"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cartes-collections')) {
    customElements.define('cartes-collections', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.cartes-collections__track');
        this.prev = this.querySelector('[data-cc-prev]');
        this.next = this.querySelector('[data-cc-next]');
        if (!this.track || !this.prev || !this.next) return;
        this.abort?.abort();
        this.abort = new AbortController();
        const { signal } = this.abort;
        const update = () => {
          const max = this.track.scrollWidth - this.track.clientWidth;
          const overflow = max > 2 && getComputedStyle(this.track).overflowX !== 'visible';
          this.toggleAttribute('data-overflow', overflow);
          this.prev.disabled = !overflow || this.track.scrollLeft <= 2;
          this.next.disabled = !overflow || this.track.scrollLeft >= max - 2;
        };
        const scroll = (direction) => {
          const item = this.track.firstElementChild;
          const step = item ? item.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).columnGap || 0) : this.track.clientWidth;
          const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.track.scrollBy({ left: direction * step, behavior: reduced ? 'auto' : 'smooth' });
        };
        this.prev.addEventListener('click', () => scroll(-1), { signal });
        this.next.addEventListener('click', () => scroll(1), { signal });
        this.track.addEventListener('scroll', update, { passive: true, signal });
        this.addEventListener('shopify:block:select', (event) => {
          event.target.scrollIntoView({ block: 'nearest', inline: 'start' });
        }, { signal });
        this.resizeObserver = new ResizeObserver(update);
        this.resizeObserver.observe(this.track);
        update();
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.resizeObserver?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-vedette"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('collection-vedette')) {
    customElements.define('collection-vedette', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.collection-vedette__track');
        this.prev = this.querySelector('[data-cv-prev]');
        this.next = this.querySelector('[data-cv-next]');
        if (!this.track || !this.prev || !this.next) return;
        this.abort?.abort();
        this.abort = new AbortController();
        const { signal } = this.abort;
        const update = () => {
          const max = this.track.scrollWidth - this.track.clientWidth;
          const overflow = max > 2 && getComputedStyle(this.track).overflowX !== 'visible';
          this.toggleAttribute('data-overflow', overflow);
          this.prev.disabled = !overflow || this.track.scrollLeft <= 2;
          this.next.disabled = !overflow || this.track.scrollLeft >= max - 2;
        };
        const scroll = (direction) => {
          const item = this.track.querySelector('.collection-vedette__item--product') || this.track.firstElementChild;
          const step = item ? item.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).columnGap || 0) : this.track.clientWidth;
          const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.track.scrollBy({ left: direction * step, behavior: reduced ? 'auto' : 'smooth' });
        };
        this.prev.addEventListener('click', () => scroll(-1), { signal });
        this.next.addEventListener('click', () => scroll(1), { signal });
        this.track.addEventListener('scroll', update, { passive: true, signal });
        this.addEventListener('shopify:block:select', (event) => {
          event.target.scrollIntoView({ block: 'nearest', inline: 'start' });
        }, { signal });
        this.resizeObserver = new ResizeObserver(update);
        this.resizeObserver.observe(this.track);
        update();
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.resizeObserver?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-home"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hero-home')) {
    customElements.define('hero-home', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        this.addEventListener('click', (event) => {
          const link = event.target.closest('[data-hero-reviews]');
          if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button > 0) return;
          const target = document.getElementById(link.hash.slice(1));
          if (!target) return;
          event.preventDefault();
          const configuredOffset = parseInt(getComputedStyle(this).getPropertyValue('--hh-scroll-offset'), 10) || 0;
          const stickyHeader = document.querySelector('sticky-header, .shopify-section-header-sticky');
          const headerOffset = stickyHeader ? Math.max(0, stickyHeader.getBoundingClientRect().bottom) + 16 : 0;
          const top = Math.max(0, target.getBoundingClientRect().top + window.scrollY - Math.max(configuredOffset, headerOffset));
          const hadTabindex = target.hasAttribute('tabindex');
          if (!hadTabindex) target.setAttribute('tabindex', '-1');
          target.focus({ preventScroll: true });
          if (!hadTabindex) target.addEventListener('blur', () => target.removeAttribute('tabindex'), { once: true });
          window.scrollTo({ top, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
          history.replaceState(history.state, '', link.hash);
        }, { signal: this.abort.signal });
      }
      disconnectedCallback() { this.abort?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maillots-decouvrir"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('maillots-decouvrir')) {
    customElements.define('maillots-decouvrir', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.maillots-decouvrir__track');
        this.prev = this.querySelector('[data-md-prev]');
        this.next = this.querySelector('[data-md-next]');
        if (!this.track || !this.prev || !this.next) return;
        this.abort?.abort();
        this.abort = new AbortController();
        const { signal } = this.abort;
        const update = () => {
          const max = this.track.scrollWidth - this.track.clientWidth;
          const overflow = max > 2 && getComputedStyle(this.track).overflowX !== 'visible';
          this.toggleAttribute('data-overflow', overflow);
          this.prev.disabled = !overflow || this.track.scrollLeft <= 2;
          this.next.disabled = !overflow || this.track.scrollLeft >= max - 2;
        };
        const scroll = (direction) => {
          const item = this.track.firstElementChild;
          const step = item ? item.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).columnGap || 0) : this.track.clientWidth;
          const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.track.scrollBy({ left: direction * step, behavior: reduced ? 'auto' : 'smooth' });
        };
        this.prev.addEventListener('click', () => scroll(-1), { signal });
        this.next.addEventListener('click', () => scroll(1), { signal });
        this.track.addEventListener('scroll', update, { passive: true, signal });
        this.addEventListener('shopify:block:select', (event) => {
          event.target.scrollIntoView({ block: 'nearest', inline: 'start' });
        }, { signal });
        this.resizeObserver = new ResizeObserver(update);
        this.resizeObserver.observe(this.track);
        update();
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.resizeObserver?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ronds-collections"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ronds-collections')) {
    customElements.define('ronds-collections', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.ronds-collections__track');
        this.prev = this.querySelector('[data-rc-prev]');
        this.next = this.querySelector('[data-rc-next]');
        if (!this.track || !this.prev || !this.next) return;
        this.abort?.abort();
        this.abort = new AbortController();
        const { signal } = this.abort;
        const update = () => {
          const max = this.track.scrollWidth - this.track.clientWidth;
          const overflow = max > 2;
          this.toggleAttribute('data-overflow', overflow);
          this.prev.disabled = !overflow || this.track.scrollLeft <= 2;
          this.next.disabled = !overflow || this.track.scrollLeft >= max - 2;
        };
        const scroll = (direction) => {
          const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.track.scrollBy({ left: direction * this.track.clientWidth * 0.8, behavior: reduced ? 'auto' : 'smooth' });
        };
        this.prev.addEventListener('click', () => scroll(-1), { signal });
        this.next.addEventListener('click', () => scroll(1), { signal });
        this.track.addEventListener('scroll', update, { passive: true, signal });
        this.addEventListener('shopify:block:select', (event) => {
          event.target.scrollIntoView({ block: 'nearest', inline: 'center' });
        }, { signal });
        this.resizeObserver = new ResizeObserver(update);
        this.resizeObserver.observe(this.track);
        update();
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.resizeObserver?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vanson-story"] && !Shopify.designMode) return;
  try {
    
function setupVansonBar(){
 const bar=document.querySelector('.v-mobile-bar');
 const main=document.querySelector('[id^="MainProduct-"]');
 if(!bar||!main||bar.dataset.ready)return;
 bar.dataset.ready='true';
 const button=bar.querySelector('.v-sticky-button');
 const price=bar.querySelector('[data-v-sticky-price]');
 const size=bar.querySelector('[data-v-sticky-size]');
 const label=bar.querySelector('[data-v-sticky-label]');
 const defaultLabel=label.textContent;
 let pending=false;
 function submitButton(){return main.querySelector('product-form button[type="submit"]');}
 function updateBar(){
  pending=false;
  const submit=submitButton();
  bar.hidden=!submit||submit.getBoundingClientRect().bottom>=0;
  if(!submit)return;
  const currentPrice=main.querySelector('[data-v-price]');
  const currentSize=Array.from(main.querySelectorAll('variant-selects input[type="radio"]:checked,variant-radios input[type="radio"]:checked,variant-selects select')).map(el=>el.value).filter(Boolean).join(' / ');
  if(currentPrice)price.textContent=currentPrice.textContent.trim();
  if(currentSize)size.value=currentSize;
  button.disabled=submit.disabled||submit.classList.contains('loading')||submit.getAttribute('aria-disabled')==='true';
  const nativeLabel=submit.querySelector('.main-atc__label__text');
  label.textContent=submit.disabled&&nativeLabel?nativeLabel.textContent.trim():defaultLabel;
 }
 function scheduleBar(){if(!pending){pending=true;requestAnimationFrame(updateBar);}}
 window.addEventListener('scroll',scheduleBar,{passive:true});
 window.addEventListener('resize',scheduleBar);
 main.addEventListener('change',scheduleBar);
 new MutationObserver(scheduleBar).observe(main,{childList:true,subtree:true,attributes:true,attributeFilter:['disabled','aria-disabled','class']});
 size.addEventListener('change',()=>{
  const picker=main.querySelector('variant-selects,variant-radios');
  if(!picker)return;
  const radio=Array.from(picker.querySelectorAll('input[type="radio"]')).find(input=>input.value===size.value);
  if(radio&&!radio.disabled)radio.click();
  else{
   const select=picker.querySelector('select');
   if(select){select.value=size.value;select.dispatchEvent(new Event('change',{bubbles:true}));}
  }
  scheduleBar();
 });
 button.addEventListener('click',()=>{
  const submit=submitButton();
  if(!submit||submit.disabled||submit.getAttribute('aria-disabled')==='true')return;
  submit.click();
  scheduleBar();
 });
 document.querySelectorAll('.v-faq a[href="#vanson-size"]').forEach(link=>link.addEventListener('click',()=>{const guide=main.querySelector('.v-guide');if(guide)guide.open=true;}));
 updateBar();
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',setupVansonBar);
else setupVansonBar();
document.addEventListener('shopify:section:load',setupVansonBar);

  } catch(e) { console.error(e); }
})();
})();
